import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";
import "animate.css";
import logo1 from "../assets/logo1.png";
import FreeTrialModal from "./FreeTrialModal";

const ContactPage = () => {
  const [showTrial, setShowTrial] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div>
      {/* SEO */}
      <Helmet>
        <title>Contact Us | Screenify – AI Recruitment Platform</title>
        <meta
          name="description"
          content="Contact Screenify for AI recruitment, resume screening, hiring automation, and onboarding assistance."
        />
        <link rel="canonical" href="https://theairecruiter.ai/contact" />
      </Helmet>

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg bg-white shadow-sm sticky-top">
        <div className="container">
          <Link className="navbar-brand mx-auto" to="/home">
            <img src={logo1} alt="logo" style={{ height: "50px" }} />
            <span className="web-name ms-2">Screenify</span>
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse justify-content-between"
            id="navbarNav"
          >
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/ai-recruiter">
                  AI Recruiter
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About us
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link active fw-semibold" to="/contact">
                  Contact
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/blog">
                  Blog
                </Link>
              </li>

              {/* <li className="nav-item">
                <button
                  className="btn btn-warning"
                  onClick={() => setShowTrial(true)}
                >
                  Free Trial
                </button>
                <FreeTrialModal
                  show={showTrial}
                  onClose={() => setShowTrial(false)}
                />
              </li> */}
            </ul>

            <ul className="navbar-nav ms-lg-auto mt-3 mt-lg-0 text-center">
              <li className="nav-item mb-2 mb-lg-0 me-lg-2">
                <button
                  className="btn btn-warning w-100 w-lg-auto"
                  onClick={() => setShowTrial(true)}
                >
                  Free Trial
                </button>
                <FreeTrialModal
                  show={showTrial}
                  onClose={() => setShowTrial(false)}
                />
              </li>

              <li className="nav-item mb-2 mb-lg-0 me-lg-2">
                <Link
                  className="btn btn-outline-primary w-100 w-lg-auto"
                  to="/login"
                >
                  Login
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className="btn btn-outline-primary w-100 w-lg-auto"
                  to="/signup"
                >
                  Sign Up
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section
        className="text-center text-white"
        style={{
          background: "linear-gradient(135deg, #007bff, #00c6ff)",
          padding: "100px 0",
        }}
      >
        <div className="container" data-aos="fade-up">
          <h1 className="display-4 fw-bold animate__animated animate__fadeInDown">
            Contact Us
          </h1>
          <p className="lead mt-3 animate__animated animate__fadeInUp">
            We're here to help! Reach out anytime for support, demo, or queries.
          </p>
        </div>
      </section>

      <section className="contact-info py-5">
        <div className="container">
          <h2 className="text-center mb-4">Our Location</h2>
          <div className="row align-items-center">
            {/* Visit Us */}
            <div className="col-md-6 mb-4 text-center ">
              <i className="fas fa-map-marker-alt fa-3x text-primary mb-3"></i>
              <h5>Visit Us</h5>
              <p>
                91springboard Outer Ring Road (ORR Mahadevapura Service Lane),
                512/10, Outer Ring Rd, Mahadevapura, Bengaluru, Karnataka
                560048, India
              </p>
            </div>

            {/* Google Map */}
            <div className="col-md-6 mb-4">
              <div className="embed-responsive embed-responsive-16by9 shadow-lg rounded">
                <iframe
                  className="embed-responsive-item"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.526176034325!2d77.6867236!3d12.9889459!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae116f8918536b%3A0x8115c810937720fd!2s91Springboard%20ORR%20Mahadevapura!5e0!3m2!1sen!2sin!4v1690973640839!5m2!1sen!2sin"
                  width="100%"
                  height="300"
                  allowFullScreen=""
                  loading="lazy"
                  title="Google Maps Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-5 bg-dark">
        <div className="container text-center text-white">
          <h2
            className="fw-bold display-5"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Get in Touch
          </h2>
          <p className="mb-4" data-aos="fade-up" data-aos-delay="300">
            We’d love to hear from you! Reach out with any questions or
            feedback.
          </p>

          <div
            className="row g-4 justify-content-center"
            style={{ borderBottom: "2px solid rgba(255, 255, 255, 0.3)" }}
          >
            {[
              {
                title: "Call Us",
                icon: "fas fa-phone-alt",
                lines: ["+91 96115 12281", "+91 90083 09255"],
                color: "text-primary",
              },
              {
                title: "Email",
                icon: "fas fa-envelope",
                lines: ["contactus@archipeltechnologies.com"],
                color: "text-warning",
              },
              {
                title: "Follow Us",
                icon: "fas fa-share-alt",
                social: true,
              },
            ].map((item, i) => (
              <div
                className="col-md-4 mb-3"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 200}
              >
                <div
                  className="p-4 rounded-4 shadow text-center hover-scale"
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <i className={`${item.icon} fa-3x mb-3 ${item.color}`}></i>
                  <h5 className="fw-bold mb-3">{item.title}</h5>

                  {item.social ? (
                    <div>
                      <a href="#" className="me-3">
                        <i className="fab fa-linkedin fa-2x text-primary"></i>
                      </a>
                      <a href="#" className="me-3">
                        <i
                          className="fab fa-instagram fa-2x"
                          style={{ color: "#E4405F" }}
                        ></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-youtube fa-2x text-danger"></i>
                      </a>
                    </div>
                  ) : (
                    item.lines.map((line, idx) => (
                      <p key={idx} className="mb-1">
                        {item.icon === "fas fa-envelope" ? (
                          <a
                            href={`mailto:${line}`}
                            className="text-decoration-none text-white"
                          >
                            <i className={`${item.icon} me-2 text-warning`}></i>
                            {line}
                          </a>
                        ) : (
                          <a
                            href={`tel:${line}`}
                            className="text-decoration-none text-white"
                          >
                            <i className={`${item.icon} me-2 text-primary`}></i>
                            {line}
                          </a>
                        )}
                      </p>
                    ))
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer
        className="bg-white text-dark py-3"
        // style={{
        //   background: "linear-gradient(90deg, #007bff, #00c6ff)",
        // }}
      >
        <div className="container d-flex flex-column flex-lg-row justify-content-between align-items-center text-center">
          <p className="mb-0">
            © Copyright {new Date().getFullYear()} Archipel Technlogies Pvt Ltd.
            . All Rights Reserved.
          </p>
          <div>
            <Link className="text-dark me-3" to="/privacy-policy">
              Privacy & Cookies
            </Link>
            <Link className="text-dark" to="/terms-and-conditions">
              Terms of Use
            </Link>
          </div>
        </div>
      </footer>

      {/* Extra CSS */}
      <style>{`
        .hover-scale:hover {
          transform: translateY(-6px);
          transition: 0.3s;
        }
      `}</style>
    </div>
  );
};

export default ContactPage;
